module.exports = "../../../../platform/assets/pageMainIcon/youth_baobiaochaxunlei7.svg";